import type { ConfigMap, FinalConfigMap, SubsPlanType } from '@/app/types';

/**
 * 将 ConfigMap 转换为 FinalConfigMap
 * 逐个遍历并转换每个元素，将字符串转换为选项对象，保持已有的选项对象不变
 */
export const transformSettings = (configMap: ConfigMap): FinalConfigMap => {
  const result: FinalConfigMap = {} as FinalConfigMap;
  const checkItemMap: Record<string, Record<string, SubsPlanType[]>> = {};

  Object.entries(configMap).forEach(([key, value]) => {
    const settingKey = key as keyof ConfigMap;

    checkItemMap[key] = {};

    if (Array.isArray(value)) {
      // 逐个遍历数组中的每个元素进行转换
      result[settingKey] = value.map((item) => {
        // 如果是字符串，转换为 ConfigItemOption 对象
        if (typeof item === 'string') {
          const configItem = {
            value: item,
            label: item,
            showVip: false,
            remainingTrials: 0,
            subPlans: [],
          };

          // 设置 checkItemMap
          checkItemMap[key][item] = [];

          return configItem;
        }

        // 如果已经是对象，直接返回（保持原有属性）
        const configItem = item;

        // 当 item 内存在 subPlan 时，新增 checkItemMap[key][value] = subPlan
        if (configItem.subPlans && configItem.subPlans.length > 0) {
          checkItemMap[key][configItem.value] = configItem.subPlans;
        } else {
          checkItemMap[key][configItem.value] = [];
        }

        return configItem;
      });
    } else {
      // 非数组情况，返回空的 ConfigItemOptions
      result[settingKey] = [];
    }
  });

  const checkOptionValue = ({
    key,
    value,
    subsPlan = 'free',
  }: {
    key: string;
    value: string;
    subsPlan?: SubsPlanType;
  }) => {
    // 获取该选项需要的订阅计划
    const requiredPlans = checkItemMap[key]?.[value] || [];

    // 如果该选项不需要特定计划，则不需要升级
    if (requiredPlans.length === 0) {
      return false;
    }

    return !requiredPlans.includes(subsPlan);
  };

  result.checkItemMap = checkItemMap;
  result.checkOptionValue = checkOptionValue;

  return result;
};
